import { render, staticRenderFns } from "./PacienteMasVisitas.vue?vue&type=template&id=f6f5d6f8&scoped=true"
import script from "./PacienteMasVisitas.vue?vue&type=script&lang=js"
export * from "./PacienteMasVisitas.vue?vue&type=script&lang=js"
import style0 from "./PacienteMasVisitas.vue?vue&type=style&index=0&id=f6f5d6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f5d6f8",
  null
  
)

export default component.exports